<template>
    <div>
        <div class="card">
            <h4 class="card__title">Anonymisering & Registerutdrag</h4>

            <div class="w-full bg-neutral-lightest p-xl">
                <div class="flex flex-wrap w-full lg:w-3/4">
                    <div class="w-full md:w-2/5">
                        <search-select
                            v-model="selectedProject"
                            class="bg-white"
                            :options="options"
                            placeholder="Välj projekt"
                        />
                    </div>
                    <div class="w-full md:w-1/5 px-lg pt-lg text-xs text-center font-bold">
                        <span>Eller</span>
                    </div>
                    <div class="w-full md:w-2/5 mt-md md:mt-0 md:relative">
                        <div class="form-group form-input-with-icon md:absolute">
                            <font-awesome-icon icon="search" class="text-xs" />
                            <input
                                v-model="addressQuery"
                                type="text"
                                class="form-input"
                                style="height: 56px;"
                                placeholder="Sök på kund eller adress"
                                @keydown.enter="searchAddresses"
                            >
                        </div>
                    </div>
                </div>
            </div>

            <div class="w-full relative">
                <div v-if="loading" class="absolute pin-t pin-x text-center mt-6xl">
                    <font-awesome-icon
                        icon="spinner"
                        spin
                        pulse
                        size="2x"
                    />
                </div>

                <projects-table
                    v-if="selectedProject"
                    :projects="filteredProjects"
                    :authorized-to-anonymize="authorizedToAnonymize"
                    @projects-updated="updateProjects"
                />
                <addresses-table
                    v-if="hasAddresses && hasSearchedAddresses"
                    :addresses="addresses"
                    :authorized-to-anonymize="authorizedToAnonymize"
                    :authorized-to-request-excerpt="authorizedToRequestExcerpt"
                    @addresses-updated="updateAddresses"
                />

                <table v-if="! hasAddresses && hasSearchedAddresses" class="table">
                    <tr>
                        <td colspan="5" class="empty-state border-0">
                            Inga resultat kunde hittas.
                        </td>
                    </tr>
                </table>
            </div>
        </div>

        <div v-if="! selectedProject && ! hasSearchedAddresses && authorizedToAnonymize">
            <project-anonymization-requests
                :initial-anonymization-requests="projectAnonymizationRequests"
            />
            <customer-anonymization-requests
                :initial-anonymization-requests="customerAnonymizationRequests"
            />
        </div>
    </div>
</template>
<script>
    import AddressesTable from './AddressesTable';
    import ProjectsTable from './ProjectsTable';

    export default {
        components: { AddressesTable, ProjectsTable },
        props: {
            initialProjects: {
                type: Array,
                required: true,
            },
            projectAnonymizationRequests: {
                type: Array,
                required: true,
            },
            customerAnonymizationRequests: {
                type: Array,
                required: true,
            },
            authorizedToAnonymize: {
                required: true,
                type: Boolean,
            },
            authorizedToRequestExcerpt: {
                required: true,
                type: Boolean,
            },
        },

        data() {
            return {
                projects: this.initialProjects,
                selectedProject: null,
                addressQuery: '',
                hasSearchedAddresses: false,
                loading: false,
                addresses: [],
            };
        },

        computed: {
            options() {
                return this.projects.map(project => project.name);
            },

            hasAddresses() {
                return this.addresses.length > 0;
            },

            filteredProjects() {
                return this.projects.filter(project => project.name === this.selectedProject);
            },
        },

        watch: {
            selectedProject() {
                if (this.selectedProject) {
                    this.addressQuery = '';
                    this.hasSearchedAddresses = false;
                }
            },
        },

        methods: {
            searchAddresses() {
                this.selectedProject = null;
                this.loading = true;

                axios.get(route('api.gdpr.search-addresses'), {
                        params: { query: this.addressQuery },
                    })
                    .then(({ data }) => {
                        this.addresses = data;

                        this.hasSearchedAddresses = true;
                        this.loading = false;
                    });
            },

            updateProjects() {
                axios.get(route('api.gdpr.projects'))
                    .then(({ data }) => {
                        this.projects = data;
                    });
            },

            updateAddresses() {
                this.searchAddresses();
            },
        },
    };
</script>
